import {ORPYX_PORTAL_URL} from "../../../../appConstants";

/**
 *  Builds a link to the patient page in the new Orpyx portal,
 *  where patient status history can be reviewed and the status changed.
 */
export const PatientPortalLinkPipe = (orpyxId: number | null | undefined): string =>
    `${ORPYX_PORTAL_URL.replace(/\/+$/, '')}/patients/${orpyxId}`;
